import { uuidV7Schema } from '@ghp/domain'
import { z } from 'zod'

/**
 * L'URL de « Réglage PDF et Contrôle » : le client, et l'un de ses secteurs (#661). C'est par elle
 * que la fiche client et l'import d'une liste ouvrent l'écran sur un secteur. Un identifiant
 * illisible retombe sur l'écran par défaut, la portée client (M21 appliqué à l'URL).
 */
export const reportRulesSearchSchema = z.object({
  client: uuidV7Schema.optional().catch(undefined),
  lot: uuidV7Schema.optional().catch(undefined),
})

export type ReportRulesSearch = z.infer<typeof reportRulesSearchSchema>
